import Bowser from 'bowser';

const browser: Bowser.Parser.Parser | null = globalThis?.navigator?.userAgent
  ? Bowser.getParser(globalThis.navigator.userAgent)
  : null;

const safeSatisfies: (checkTree: Bowser.Parser.checkTree) => boolean = (checkTree) => {
  if (!browser) {
    return false;
  }

  return browser.satisfies(checkTree) || false;
};

export const BROWSER_CAPABILITIES = {
  safari15OrHigher: safeSatisfies({
    safari: '>=15',
  }),
  firefox: safeSatisfies({
    firefox: '>0',
  }),
  safari: safeSatisfies({
    safari: '>0',
  }),
  chrome: safeSatisfies({
    chrome: '>0',
  }),
  edge: safeSatisfies({
    edge: '>0',
  }),
};
